<template>
  <div class="leave-message">
    <div class="leave-msg-container">
      <template v-if="msgList.length > 0">
        <div class="title">共计{{ totalDatas }}条评论</div>
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="msg-item" v-for="(item, index) in msgList" :key="index">
            <img v-if="item.userFace" :src="$isCdn(item.userFace)" alt />
            <img v-else :src="avatar" alt />
            <div class="msg-item-info">
              <div class="name">{{ item.userName }}</div>
              <div class="date">{{ item.eventMessageTime | formatDate('yyyy-MM-dd') }}</div>
              <div class="msg-content" v-html="filterMsg(item.eventMessageInfo)"></div>
            </div>
          </div>
        </van-list>
      </template>
      <div v-else class="no-data">
        <img src="./../../../assets/image/no-data2.png" alt="" />
        <!-- <div class="value">快来发送第一条评论</div> -->
      </div>
    </div>
    <message-btn @on-send="send" />
  </div>
</template>

<script>
import {insertMsg, getInsertMsg} from '@/api'
export default {
  components: {
    messageBtn: () => import('./../messageBtn.vue')
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  data() {
    return {
      avatar: require('@/assets/image/avatar.svg'),
      id: this.$route.params.id,
      msgList: [],
      pageNo: 1,
      pageSize: 10,
      totalPages: 0,
      totalDatas: 0,

      finished: false,
      loading: false
    }
  },
  mounted() {
    this.getMessageList()
  },
  methods: {
    onLoad() {
      if (this.pageNo >= this.totalPages) {
        this.finished = true
        return
      }
      this.pageNo += 1
      this.loading = true
      this.getMessageList()
    },
    getMessageList() {
      const params = {
        pageNo: this.pageNo,
        eventId: this.id,
        pageSize: this.pageSize
      }
      getInsertMsg(params).then(res => {
        if (res.code === 0) {
          this.msgList = [...this.msgList, ...res.data]
          this.totalDatas = res.totalDatas * 1
          this.totalPages = Math.ceil(this.totalDatas / this.pageSize)
          this.loading = false
        }
      })
    },
    send(msg) {
      if (!this.userInfo.id) {
        return this.$dialog
          .alert({
            closeOnClickOverlay: true,
            theme: 'round-button',
            confirmButtonColor: '#4465f3',
            message: '您没有登录,去登录?'
          })
          .then(() => {
            this.$router.replace(`/login?redirect=${encodeURIComponent(location.href)}`)
          })
      }
      const params = {
        eventInfoId: this.id,
        eventMessageInfo: msg,
        eventMessagePid: 0,
        eventMessageType: 2, // -留言类型 1：直播聊天，2：留言
        eventMessageTime: new Date(),
        eventMessageUserId: this.userInfo.id,
        isdeleted: false,
        orgid: 0,
        status: 0,
        tenantid: 0,
        versionnum: 0
      }
      insertMsg(params).then(result => {
        this.pageNo = 1
        // 重置
        this.finished = false
        this.msgList = []
        this.getMessageList()
      })
    },
    filterMsg(value) {
      return value.replace(/{emoji:(\d+)}/gi, function(index) {
        // eslint-disable-next-line no-unused-vars
        const [num] = index.match(/\d+/g)
        // const img = require(`./../../assets/emoji/${num}.png`)
        // eslint-disable-next-line no-undef
        return `<img style="width:18px;height:18px" src=${img}>`
      })
    }
  }
}
</script>

<style scoped lang="scss">
.leave-message {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.leave-msg-container {
  flex: 1;
  height: 0;
  background: #fff;
  padding: 20px 16px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  .title {
    color: #909399;
  }
}

.msg-item {
  position: relative;
  img {
    position: absolute;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    top: 20px;
  }
  .msg-item-info {
    padding-left: 46px;
    padding-top: 20px;
    padding-bottom: 10px;
    .name {
      color: #303133;
      font-size: 15px;
      font-weight: 500;
    }
    .date {
      font-size: 12px;
      color: #909399;
      line-height: 24px;
    }
    .msg-content {
      font-size: 13px;
      font-weight: 500;
      color: #606266;
      line-height: 24px;
      word-break: break-all;
    }
  }
}
.msg-item + .msg-item {
  border-top: 1px solid #f0f3f6;
}

.no-data {
  text-align: center;
  padding-top: 60px;
  img {
    width: 140px;
  }
}

/* .no-data {
  text-align: center;
  img {
    margin-top: 40px;
    width: 80px;
  }
  .value {
    color: #c0c4cc;
  }
} */
</style>
